"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6570],{

/***/ 37139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ TooltipWithRef; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);






var TooltipWithRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Tooltip */ .u, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref
    }, props), {
        children: children
    }));
});
TooltipWithRef.displayName = "TooltipWithRef";


/***/ }),

/***/ 98781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ BudgetDisplayMode; },
  "E": function() { return /* binding */ BudgetPerAsset; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(59656);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/UI/Pill.tsx
var Pill = __webpack_require__(50850);
// EXTERNAL MODULE: ./components/common/TooltipWithRef.tsx
var TooltipWithRef = __webpack_require__(37139);
;// CONCATENATED MODULE: ./components/display/BonusMultiplierBreakdown.tsx


var BonusMultiplierBreakdown = function(param) {
    var rarityDetails = param.rarityDetails, baseRoyaltyPercentage = param.baseRoyaltyPercentage, adjustedRoyaltyPercentage = param.adjustedRoyaltyPercentage, bonusConfig = param.bonusConfig;
    if (rarityDetails.length === 0 || !bonusConfig) return null;
    var rarityColorClass = function(rarity, bonusConfig) {
        var ref;
        var color = ((ref = bonusConfig.rarityConfigs[rarity]) === null || ref === void 0 ? void 0 : ref.color) || "gray";
        return "bg-".concat(color, "-500");
    };
    var renderTableRow = function(detail, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "py-0.5 text-right",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inline-flex items-center justify-center rounded-lg px-2 py-1 text-white ".concat(rarityColorClass(detail.rarity, bonusConfig)),
                        children: detail.rarity
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "text-center",
                    children: detail.count
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                    className: "text-left",
                    children: [
                        detail.bonusPercentage,
                        "%"
                    ]
                })
            ]
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            className: "pb-1 pt-1.5 text-right",
                            children: "Rarity"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            className: "px-2 pb-1 pt-1.5 text-center",
                            children: "#"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            className: "pb-1 pt-1.5 text-left",
                            children: "Bonus"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                children: rarityDetails.filter(function(detail) {
                    return detail.rarity !== "Unknown";
                }).map(renderTableRow)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tfoot", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                colSpan: 2,
                                className: "pr-2 pt-3 text-right",
                                children: "Base Royalty"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                className: "pt-3 text-left",
                                children: [
                                    baseRoyaltyPercentage,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                colSpan: 2,
                                className: "pb-2 pl-4 pr-2 text-right font-bold",
                                children: "Adjusted Royalty"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                className: "pb-2 pr-4 text-left font-bold",
                                children: [
                                    adjustedRoyaltyPercentage,
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var display_BonusMultiplierBreakdown = (BonusMultiplierBreakdown);

// EXTERNAL MODULE: ./components/formatting/TitleWithChildren.tsx
var TitleWithChildren = __webpack_require__(21549);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69702);
// EXTERNAL MODULE: ./constants/constants.ts
var constants = __webpack_require__(36630);
// EXTERNAL MODULE: ./utilities/fetchNfts.ts
var fetchNfts = __webpack_require__(21105);
;// CONCATENATED MODULE: ./hooks/useBonusMultiplier.tsx







var getRarityValue = function(metadata, rarityConfigs, metadataTraitName) {
    var ref, ref1;
    var ref2;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var rarity = (ref2 = (ref = metadata.attributes) === null || ref === void 0 ? void 0 : ref[metadataTraitName]) !== null && ref2 !== void 0 ? ref2 : "Unknown";
    var ref3;
    return (ref3 = (ref1 = rarityConfigs[rarity]) === null || ref1 === void 0 ? void 0 : ref1.multiplier) !== null && ref3 !== void 0 ? ref3 : rarityConfigs["Unknown"].multiplier;
};
var calculateMultiplierCount = function(nftCount, multiplierThresholdConfig) {
    for(var i = 0; i < multiplierThresholdConfig.thresholds.length; i++){
        if (nftCount >= multiplierThresholdConfig.thresholds[i]) return multiplierThresholdConfig.multipliers[i];
    }
    return nftCount >= 1 ? 1 : 0;
};
var processRarityDetails = function(sortedNfts, basePercentage, maximumBonusPercent, metadataTraitName, rarityConfigs, multiplierThresholdConfig) {
    var rarityCounts = Object.fromEntries(Object.keys(rarityConfigs).map(function(key) {
        return [
            key,
            {
                count: 0,
                multiplier: 0
            }, 
        ];
    }));
    var bonusPercentage = 0;
    var multiplierCount = calculateMultiplierCount(sortedNfts.length, multiplierThresholdConfig);
    var details = [];
    for(var i = 0; i < multiplierCount && bonusPercentage < maximumBonusPercent; i++){
        var currentMultiplier = getRarityValue(sortedNfts[i].metadata, rarityConfigs, metadataTraitName);
        var attributes = sortedNfts[i].metadata.attributes;
        var _metadataTraitName;
        var rarityType = attributes ? (_metadataTraitName = attributes[metadataTraitName]) !== null && _metadataTraitName !== void 0 ? _metadataTraitName : "Unknown" : "Unknown";
        if (bonusPercentage + currentMultiplier > maximumBonusPercent) {
            currentMultiplier = maximumBonusPercent - bonusPercentage;
        }
        bonusPercentage += currentMultiplier;
        rarityCounts[rarityType].count++;
        rarityCounts[rarityType].multiplier += currentMultiplier;
    }
    details = Object.entries(rarityCounts).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), rarity = _param[0], ref = _param[1], count = ref.count, multiplier = ref.multiplier;
        return {
            rarity: rarity,
            count: count,
            multiplier: multiplier,
            bonusPercentage: multiplier * basePercentage / 100
        };
    });
    // Sort results to always appear in descending rarity multiplier order, e.g. so that Mythical is always first and Common last
    details.sort(function(a, b) {
        var ref, ref1;
        var ref2;
        var multiplierA = (ref2 = (ref = rarityConfigs[a.rarity]) === null || ref === void 0 ? void 0 : ref.multiplier) !== null && ref2 !== void 0 ? ref2 : 0;
        var ref3;
        var multiplierB = (ref3 = (ref1 = rarityConfigs[b.rarity]) === null || ref1 === void 0 ? void 0 : ref1.multiplier) !== null && ref3 !== void 0 ? ref3 : 0;
        return multiplierB - multiplierA;
    });
    return {
        details: details,
        bonusPercentage: bonusPercentage
    };
};
var useBonusMultiplier = function(param) {
    var address = param.address, baseCollection = param.baseCollection, bonusCollection = param.bonusCollection, _basePercentage = param.basePercentage, basePercentage = _basePercentage === void 0 ? 0 : _basePercentage, opportunityPublishedDate = param.opportunityPublishedDate, bonusConfig = param.bonusConfig;
    var defaultAccount = (0,dist/* useAccount */.mA)();
    var ref = (0,react.useState)(0), bonusMultiplier = ref[0], setBonusMultiplier = ref[1];
    var ref1 = (0,react.useState)(basePercentage), adjustedAmount = ref1[0], setAdjustedAmount = ref1[1];
    var ref2 = (0,react.useState)([]), rarityDetails = ref2[0], setRarityDetails = ref2[1];
    var ref3 = (0,react.useState)(null), error = ref3[0], setError = ref3[1];
    address = address !== null && address !== void 0 ? address : defaultAccount === null || defaultAccount === void 0 ? void 0 : defaultAccount.address;
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var twoWeeksBeforeOpportunity, bonusNfts, totalNfts, sortedNfts, ref, details, bonusPercentage, adjustedMultiplier;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(!address || !baseCollection || !bonusCollection || !opportunityPublishedDate || !bonusConfig)) {
                                _ctx.next = 5;
                                break;
                            }
                            setBonusMultiplier(basePercentage);
                            setAdjustedAmount(basePercentage);
                            setRarityDetails([]);
                            return _ctx.abrupt("return");
                        case 5:
                            _ctx.prev = 5;
                            twoWeeksBeforeOpportunity = new Date(opportunityPublishedDate);
                            twoWeeksBeforeOpportunity.setDate(twoWeeksBeforeOpportunity.getDate() - 14);
                            _ctx.next = 10;
                            return (0,fetchNfts/* fetchNfts */.A)(address, [
                                bonusCollection
                            ], constants/* CHAIN_ID */.Kj);
                        case 10:
                            bonusNfts = _ctx.sent;
                            totalNfts = bonusNfts.flatMap(function(collection) {
                                return collection.nfts.filter(function(nft) {
                                    if (nft.acquiredAt && nft.acquiredAt.blockTimestamp) {
                                        var acquiredDate = new Date(nft.acquiredAt.blockTimestamp);
                                        return acquiredDate <= twoWeeksBeforeOpportunity;
                                    }
                                    return false;
                                }).map(function(nft) {
                                    return {
                                        metadata: nft.rawMetadata
                                    };
                                });
                            });
                            sortedNfts = totalNfts.sort(function(a, b) {
                                return getRarityValue(b.metadata, bonusConfig.rarityConfigs, bonusConfig.metadataTraitName) - getRarityValue(a.metadata, bonusConfig.rarityConfigs, bonusConfig.metadataTraitName);
                            });
                            ref = processRarityDetails(sortedNfts, basePercentage, bonusConfig.maximumBonusPercentage, bonusConfig.metadataTraitName, bonusConfig.rarityConfigs, bonusConfig.multiplierThresholdConfig), details = ref.details, bonusPercentage = ref.bonusPercentage;
                            adjustedMultiplier = 1 + bonusPercentage / 100;
                            setRarityDetails(details);
                            setBonusMultiplier(adjustedMultiplier);
                            setAdjustedAmount(basePercentage + basePercentage * bonusPercentage / 100);
                            _ctx.next = 23;
                            break;
                        case 20:
                            _ctx.prev = 20;
                            _ctx.t0 = _ctx["catch"](5);
                            setError("Error calculating bonus multiplier");
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        5,
                        20
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        void fetchData();
    }, [
        address,
        bonusCollection,
        baseCollection,
        basePercentage,
        opportunityPublishedDate,
        bonusConfig, 
    ]);
    return {
        bonusMultiplier: bonusMultiplier,
        adjustedAmount: adjustedAmount,
        rarityDetails: rarityDetails,
        error: error
    };
};
/* harmony default export */ var hooks_useBonusMultiplier = (useBonusMultiplier);

// EXTERNAL MODULE: ./utilities/budgetFormatter.ts
var budgetFormatter = __webpack_require__(40822);
// EXTERNAL MODULE: ./utilities/tailwind.ts
var tailwind = __webpack_require__(88651);
;// CONCATENATED MODULE: ./components/display/BudgetPerAsset.tsx










var BudgetDisplayMode;
(function(BudgetDisplayMode) {
    BudgetDisplayMode[BudgetDisplayMode["WITH_TITLE"] = 0] = "WITH_TITLE";
    BudgetDisplayMode[BudgetDisplayMode["WITHOUT_TITLE"] = 1] = "WITHOUT_TITLE";
})(BudgetDisplayMode || (BudgetDisplayMode = {}));
var BudgetPerAsset = function(param) {
    var address = param.address, paymentCurrency = param.paymentCurrency, minBudget = param.minBudget, maxBudget = param.maxBudget, royaltyPercentage = param.royaltyPercentage, collectionAddress = param.collectionAddress, bonusConfig = param.bonusConfig, _displayMode = param.displayMode, displayMode = _displayMode === void 0 ? BudgetDisplayMode.WITH_TITLE : _displayMode, publishedDate = param.publishedDate, _isCreatingDeal = param.isCreatingDeal, isCreatingDeal = _isCreatingDeal === void 0 ? false : _isCreatingDeal, classes = param.classes;
    var ref;
    var upfrontText = (0,react.useMemo)(function() {
        return getUpfrontText(minBudget, maxBudget, royaltyPercentage, paymentCurrency, isCreatingDeal);
    }, [
        minBudget,
        maxBudget,
        royaltyPercentage,
        paymentCurrency,
        isCreatingDeal
    ]);
    var baseCollection = (0,react.useMemo)(function() {
        return collectionAddress ? {
            name: "Base Collection",
            nft_contract_address: collectionAddress
        } : undefined;
    }, [
        collectionAddress
    ]);
    var bonusCollection = (0,react.useMemo)(function() {
        return (bonusConfig === null || bonusConfig === void 0 ? void 0 : bonusConfig.contractAddress) ? {
            name: "Bonus Collection",
            nft_contract_address: bonusConfig === null || bonusConfig === void 0 ? void 0 : bonusConfig.contractAddress
        } : undefined;
    }, [
        bonusConfig === null || bonusConfig === void 0 ? void 0 : bonusConfig.contractAddress
    ]);
    var bonusResult = hooks_useBonusMultiplier({
        address: address,
        baseCollection: baseCollection,
        bonusCollection: bonusCollection,
        basePercentage: royaltyPercentage,
        opportunityPublishedDate: publishedDate,
        bonusConfig: bonusConfig
    });
    var _adjustedAmount;
    var adjustedAmount = (0,react.useMemo)(function() {
        return collectionAddress && displayMode === BudgetDisplayMode.WITH_TITLE ? (_adjustedAmount = bonusResult.adjustedAmount) !== null && _adjustedAmount !== void 0 ? _adjustedAmount : 0 : 0;
    }, [
        bonusResult.adjustedAmount,
        collectionAddress,
        displayMode
    ]);
    if (displayMode === BudgetDisplayMode.WITHOUT_TITLE) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col ".concat(royaltyPercentage ? "text-[13px]" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: upfrontText
                }),
                royaltyPercentage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-1",
                    children: [
                        "Royalty Percentage: ",
                        royaltyPercentage,
                        "%"
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWithChildren/* TitleWithChildren */.U, {
        title: "Est. Budget Per Asset",
        classes: classes !== null && classes !== void 0 ? classes : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-start",
            children: [
                upfrontText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* default */.ZP, {
                    theme: Pill/* PillTheme.DEFAULT */.W$.DEFAULT,
                    showDot: false,
                    classes: "inline-flex mt-0",
                    children: upfrontText
                }),
                royaltyPercentage && /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipWithRef/* TooltipWithRef */.a, {
                    label: ((ref = bonusResult.rarityDetails) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(display_BonusMultiplierBreakdown, {
                        rarityDetails: bonusResult.rarityDetails,
                        bonusConfig: bonusConfig,
                        baseRoyaltyPercentage: royaltyPercentage,
                        adjustedRoyaltyPercentage: adjustedAmount
                    }),
                    c: (0,tailwind/* getTailwindColor */.c)("neutral")["70"],
                    color: (0,tailwind/* getTailwindColor */.c)("primary").surface,
                    transitionProps: {
                        transition: "fade",
                        duration: 500
                    },
                    withArrow: true,
                    arrowSize: 8,
                    openDelay: 300,
                    position: "top",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pill/* default */.ZP, {
                        theme: Pill/* PillTheme.ORANGE */.W$.ORANGE,
                        showDot: bonusResult.bonusMultiplier !== adjustedAmount,
                        pulse: bonusResult.bonusMultiplier !== adjustedAmount,
                        classes: "mt-0 inline-flex",
                        children: [
                            "Royalty Percentage: ",
                            adjustedAmount,
                            "%"
                        ]
                    })
                })
            ]
        })
    });
};
var getUpfrontText = function(minBudget, maxBudget, royaltyPercentage, paymentCurrency, isCreatingDeal) {
    if (!minBudget || !maxBudget) return "";
    var formattedMinBudget = isCreatingDeal ? lib_esm/* parseUnits */.vz(minBudget, 6).toString() : minBudget;
    var formattedMaxBudget = isCreatingDeal ? lib_esm/* parseUnits */.vz(maxBudget, 6).toString() : maxBudget;
    return "".concat(royaltyPercentage ? "Upfront Payment: " : "").concat((0,budgetFormatter/* budgetFormatter */.n)(formattedMinBudget, formattedMaxBudget, paymentCurrency));
};


/***/ }),

/***/ 21549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ TitleWithChildren; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var TitleWithChildren = function(param) {
    var title = param.title, classes = param.classes, children = param.children;
    var className = "".concat(classes, " flex text-left flex-col");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pb-2 text-left text-neutral-50 md:text-md",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "justify-self-end pb-2 text-black md:pb-0",
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 40822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ humanizeUSDC; },
/* harmony export */   "n": function() { return /* binding */ budgetFormatter; }
/* harmony export */ });
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59656);
/* harmony import */ var numbro__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90052);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30207);
/* harmony import */ var _currencyConvert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63187);




var budgetFormatter = function(min_budget, max_budget, payment_currency) {
    var decimal = !payment_currency ? 0 : _currencyConvert__WEBPACK_IMPORTED_MODULE_2__/* .Erc20DecimalEnum */ .W5[payment_currency];
    var budgetFormatted = [];
    if (min_budget !== undefined) {
        var minBudgetFormattedValue;
        if (payment_currency === _generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .PaymentCurrency_Enum.Usdc */ .CI.Usdc) {
            minBudgetFormattedValue = ethers__WEBPACK_IMPORTED_MODULE_3__/* .formatUnits */ .bM(min_budget, 6);
            budgetFormatted.push(humanizeUSDC(ethers__WEBPACK_IMPORTED_MODULE_3__/* .parseUnits */ .vz(minBudgetFormattedValue, 6)));
        } else {
            minBudgetFormattedValue = ethers__WEBPACK_IMPORTED_MODULE_3__/* .formatUnits */ .bM(min_budget, decimal);
            budgetFormatted.push(ethers__WEBPACK_IMPORTED_MODULE_3__/* .commify */ .Fn(minBudgetFormattedValue));
        }
    }
    if (max_budget !== undefined && min_budget !== max_budget) {
        var maxBudgetFormattedValue;
        if (payment_currency === _generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .PaymentCurrency_Enum.Usdc */ .CI.Usdc) {
            maxBudgetFormattedValue = ethers__WEBPACK_IMPORTED_MODULE_3__/* .formatUnits */ .bM(max_budget, 6);
            budgetFormatted.push(humanizeUSDC(ethers__WEBPACK_IMPORTED_MODULE_3__/* .parseUnits */ .vz(maxBudgetFormattedValue, 6)));
        } else {
            maxBudgetFormattedValue = ethers__WEBPACK_IMPORTED_MODULE_3__/* .formatUnits */ .bM(max_budget, decimal);
            budgetFormatted.push(ethers__WEBPACK_IMPORTED_MODULE_3__/* .commify */ .Fn(maxBudgetFormattedValue));
        }
    }
    return budgetFormatted.length > 1 ? "".concat(budgetFormatted[0], " - ").concat(budgetFormatted[1], " ").concat(payment_currency && payment_currency !== _generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .PaymentCurrency_Enum.Usdc */ .CI.Usdc ? payment_currency : "") : budgetFormatted.length === 1 ? "".concat(budgetFormatted[0], " ").concat(payment_currency && payment_currency !== _generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .PaymentCurrency_Enum.Usdc */ .CI.Usdc ? payment_currency : "") : "";
};
var humanizeUSDC = function(value) {
    var scaledValue = ethers__WEBPACK_IMPORTED_MODULE_3__/* .formatUnits */ .bM(value.toString(), 6);
    return (0,numbro__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(scaledValue).format({
        average: true,
        mantissa: 2,
        trimMantissa: true,
        optionalMantissa: true,
        output: "currency",
        currencySymbol: "$"
    });
};


/***/ }),

/***/ 63187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ currency; },
/* harmony export */   "W5": function() { return /* binding */ Erc20DecimalEnum; },
/* harmony export */   "dq": function() { return /* binding */ currencyMap; }
/* harmony export */ });
/* unused harmony exports currencyConvert, addDecimals */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47842);
/* harmony import */ var ethers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59656);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30207);



var Erc20DecimalEnum;
(function(Erc20DecimalEnum) {
    Erc20DecimalEnum[Erc20DecimalEnum["USDC"] = 6] = "USDC";
    Erc20DecimalEnum[Erc20DecimalEnum["ETH"] = 18] = "ETH";
})(Erc20DecimalEnum || (Erc20DecimalEnum = {}));
var _obj;
var currencyMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .PaymentCurrency_Enum.Eth */ .CI.Eth, Erc20DecimalEnum.ETH), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .PaymentCurrency_Enum.Usdc */ .CI.Usdc, Erc20DecimalEnum.USDC), _obj);
var currencyConvert = function(amount, currency) {
    return ethers.utils.formatUnits(BigNumber.from(String(amount)), currency ? Erc20DecimalEnum[currency] : 18);
};
var addDecimals = function(amount, currency) {
    // TODO: fix this to Bignumbers
    return (amount * Math.pow(10, currency !== null && currency !== void 0 ? currency : 6)).toString();
};
var currency = function(value, currency) {
    if (!currency) {
        currency = _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .PaymentCurrency_Enum.Usdc */ .CI.Usdc;
    }
    return ethers__WEBPACK_IMPORTED_MODULE_2__/* .commify */ .Fn(ethers__WEBPACK_IMPORTED_MODULE_2__/* .formatUnits */ .bM(value, currencyMap[currency])) + " " + currency;
};


/***/ }),

/***/ 17695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZF": function() { return /* binding */ getLocalDate; },
/* harmony export */   "n$": function() { return /* binding */ getHumanizedDate; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "xj": function() { return /* binding */ DateThemeMap; }
/* harmony export */ });
/* unused harmony exports HumanizedDate, humanizeDate */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47842);
/* harmony import */ var moment_timezone_custom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33353);
/* harmony import */ var moment_timezone_custom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment_timezone_custom__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54764);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_UI_Pill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50850);




var formatDate = function(date, format) {
    return moment_timezone_custom__WEBPACK_IMPORTED_MODULE_0___default()(date).format(format);
};
var getLocalDate = function(date, format) {
    // create a new moment object from the UTC string
    var utcMoment = moment_timezone_custom__WEBPACK_IMPORTED_MODULE_0___default()(date);
    // convert the UTC moment object to the user's local time zone
    var localMoment = utcMoment.tz(moment_timezone_custom__WEBPACK_IMPORTED_MODULE_0___default().tz.guess()).toISOString();
    return formatDate(localMoment, format);
};
var HumanizedDate;
(function(HumanizedDate) {
    HumanizedDate["TODAY"] = "Today";
    HumanizedDate["TOMORROW"] = "Tomorrow";
    HumanizedDate["NEXT_WEEK"] = "NextWeek";
    HumanizedDate["SAME_ELSE"] = "SameElse";
    HumanizedDate["PAST"] = "Past";
})(HumanizedDate || (HumanizedDate = {}));
var _obj;
var DateThemeMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, HumanizedDate.TODAY, {
    theme: _components_UI_Pill__WEBPACK_IMPORTED_MODULE_2__/* .PillTheme.RED */ .W$.RED,
    pulse: true,
    dot: true
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, HumanizedDate.TOMORROW, {
    theme: _components_UI_Pill__WEBPACK_IMPORTED_MODULE_2__/* .PillTheme.RED */ .W$.RED,
    pulse: false,
    dot: true
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, HumanizedDate.NEXT_WEEK, {
    theme: _components_UI_Pill__WEBPACK_IMPORTED_MODULE_2__/* .PillTheme.ORANGE */ .W$.ORANGE,
    pulse: false,
    dot: true
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, HumanizedDate.SAME_ELSE, {
    theme: _components_UI_Pill__WEBPACK_IMPORTED_MODULE_2__/* .PillTheme.GREEN */ .W$.GREEN,
    pulse: false,
    dot: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, HumanizedDate.PAST, {
    theme: _components_UI_Pill__WEBPACK_IMPORTED_MODULE_2__/* .PillTheme.NEUTRAL */ .W$.NEUTRAL,
    pulse: false,
    dot: false
}), _obj);
var getHumanizedDateEnum = function(date) {
    var now = moment_timezone_custom__WEBPACK_IMPORTED_MODULE_0___default()();
    var inputDate = moment_timezone_custom__WEBPACK_IMPORTED_MODULE_0___default()(date);
    if (inputDate.isSame(now, "day")) return HumanizedDate.TODAY;
    if (inputDate.isSame(now.clone().add(1, "day"), "day")) return HumanizedDate.TOMORROW;
    if (inputDate.isAfter(now, "day") && inputDate.isBefore(now.clone().add(7, "day"), "day")) return HumanizedDate.NEXT_WEEK;
    if (inputDate.isBefore(now)) return HumanizedDate.PAST;
    return HumanizedDate.SAME_ELSE;
};
var humanizeDate = function(date) {
    return moment_timezone_custom__WEBPACK_IMPORTED_MODULE_0___default()(date).calendar(null, {
        sameDay: "[Today] @ hh:mm A",
        nextDay: "[Tomorrow]",
        nextWeek: "dddd",
        lastWeek: "[Last] dddd",
        sameElse: "MMM D, YYYY"
    });
};
var getHumanizedDate = function(date) {
    return [
        humanizeDate(date),
        getHumanizedDateEnum(date)
    ];
};


/***/ }),

/***/ 88651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getTailwindColor; }
/* harmony export */ });
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69640);
/* harmony import */ var tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tailwind_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8616);
/* harmony import */ var _tailwind_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tailwind_config__WEBPACK_IMPORTED_MODULE_1__);


var fullConfig = tailwindcss_resolveConfig__WEBPACK_IMPORTED_MODULE_0___default()((_tailwind_config__WEBPACK_IMPORTED_MODULE_1___default()));
var getTailwindColor = function(name) {
    var colorValue = fullConfig.theme.colors[name];
    if (typeof colorValue === "object" && !Array.isArray(colorValue)) {
        return colorValue;
    }
    return colorValue;
};


/***/ })

}]);